import { Injectable }    from '@angular/core';
import { environment } from '../../environments/environment';
import { Headers, Http } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { Sample } from '../entity/sample';
import 'rxjs/add/operator/toPromise';
import { Order } from '../entity/order';
import { ThirdParty } from '../entity/third-party';
import { CancellationMotive } from '../entity/cancellation-motive';
import { UploadService } from '../shared/upload.service';


@Injectable()
export class CancellationService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService, private uploadService: UploadService) {}

  getResults(takingDate, producerSiret): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/cancel/results', JSON.stringify({producerSiret: producerSiret, takingDate: takingDate}), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let samples = [];
                    let response_obj = response.json();
                    for(let index in response_obj['samples']){
                      let sample = new Sample();
                      sample.fromJSON(response_obj['samples'][index]);
                      samples[samples.length] = sample;
                    }

                    return samples;
                  }
                )
               .catch(this.handleError);
  }

  uploadFile(file): Promise<any> {
    return this.uploadService.makeFileRequest(environment.apiUrl+'site-api/upload', [file])
            .toPromise()
            .then(
              function(response) {
                return response[0];
              }
            )
            .catch(this.handleError);
  }

  cancelResults(data): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/cancellation/new', JSON.stringify(data), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let response_obj = response.json();
                    let orderCode = response_obj['orderCode'];
                    return orderCode;
                  }
                )
               .catch(this.handleError);
  }

  getCancellationOrders(criteria): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/cancellation/list', JSON.stringify(criteria), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let orders = [];
                    let response_obj = response.json();
                    let producersSirets = [];
                    let samples = response_obj['samples'];
                    let sampleResults = response_obj['sampleResults'];
                    let allOrders =  response_obj['orders'];
                    const counts = response_obj['counts'];
                    for(let index in allOrders){
                        let order = new Order();
                        order.fromJSON(response_obj['orders'][index]);
                        producersSirets[producersSirets.length] = order.thirdPartyAff.siret;
                        orders[orders.length] = order;
                      }

                    let lastComment = response_obj['lastComment'];
                    let allComments = response_obj['allComments'];
                    return [orders, producersSirets, counts, samples, sampleResults, lastComment, allComments];
                  }
                )
                .then(
                  function(data) {
                    let orders = data[0];
                    let producersSirets = data[1];
                    const counts = data[2];
                    const samples = data[3];
                    const sampleResults = data[4];
                    const lastComment = data[5];
                    const allComments = data[6];
                    return this.http.post(environment.apiUrl+'site-api/list/third-parties', JSON.stringify({thirdPartiesSirets: producersSirets}), {headers: this.headers})
                      .toPromise()
                      .then(
                        function(response) {
                          let thirdParties = {};
                          let response_obj = response.json();
                          for(let index in response_obj['thirdParties']){
                            let thirdParty = new ThirdParty();
                            thirdParty.fromJSON(response_obj['thirdParties'][index]);
                            thirdParties[thirdParty.siret] = thirdParty;
                          }
                            for(let index in orders){
                              orders[index].infos["producer"] = thirdParties[orders[index].thirdPartyAff.siret];
                            }

                          return {
                            orders: orders,
                            samples: samples,
                            sampleResults: sampleResults,
                            counts : counts,
                            lastComment: lastComment,
                            allComments: allComments
                          };
                        }
                      );
                  }.bind(this)
                )
                .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  postCancelOrder(data): Promise<any> {
    return this.http.post(environment.apiUrl + '/site-api/cancel-order', JSON.stringify(data), {headers: this.headers})
      .toPromise()
      .then(
        function (response) {
          return response.json();
        }
      )
      .catch(this.handleError);
  }

    getOrderComments(orderNumber: string) {
        return this.http.get(environment.apiUrl + '/site-api/get-order-comments?orderNumber=' + orderNumber, {headers: this.headers})
            .toPromise()
            .then(
                function (response) {
                    let response_obj = response.json();
                    let allComments = response_obj['allComments'];
                    return allComments;
                }
            )
            .catch(this.handleError);
    }

}


// WEBPACK FOOTER //
// ./src/app/cancellation/cancellation.service.ts